import { IInput, IInputConfig, Input } from "./Input";
import { SimpleSignal } from "../SimpleSignal";

export interface IBooleanInputConfig extends IInputConfig
{
	value?: boolean;
	label?: string;
	addLabel?: boolean;
	vertical?: boolean;
}

export class BooleanInput implements IInput
{
	public static defaultConfig:IBooleanInputConfig = {
		value: false
	};

	private _id: string;
	private _element: HTMLDivElement = document.createElement("div");
	private _input: HTMLInputElement = document.createElement("input");

	public changeSignal: SimpleSignal = new SimpleSignal();

	constructor(config: IBooleanInputConfig)
	{
		this._id = config.id;
		this._element.classList.add("toggleContainer");

		if (config.vertical)
		{
			this._element.classList.add("vbox");
		}

		if (config.id)
		{
			this._element.id = config.id;
		}

		if (config.addLabel && config.label)
		{
			const label = document.createElement("label");
			label.textContent = config.label;
			this._element.appendChild(label);
		}

		const label = document.createElement("label");
		label.classList.add("switch");
		
		this._input.type = "checkbox";
		this._input.addEventListener("change", this.onChange);
		label.appendChild(this._input);

		const span = document.createElement("span");
		span.classList.add("slider", "round");
		label.appendChild(span);

		this._element.appendChild(label);
	}

	private onChange = (event:Event)=>
	{
		var value = this._input.checked;
		this.value = value;

		this.changeSignal.dispatch(value, this);
	};

	public set value(value:boolean)
	{
		this._input.checked = !!value;
	}

	public get value()
	{
		return this._input.checked;
	}

	public setEnabled(value:boolean)
	{
		this._input.disabled = !value;
	}

	public setChecked(value: boolean)
	{
		this._input.checked = value;
	}

	public enable()
	{
		this._input.disabled = false;
	}

	public disable()
	{
		return this._input.disabled = true;
	}

	public get element()
	{
		return this._element;
	}

	public get input()
	{
		return this._input;
	}

	public get id()
	{
		return this._id;
	}
}